import React from 'react';
import {FieldErrors, FieldError, Control} from 'react-hook-form';
import {TextInput as Input} from '../../../../../../../../components/inputs/text';

interface IAgropecuaryFields {
  control: Control<any, undefined>;
  errors: FieldErrors | undefined;
}

export const AgropecuaryFields = (props: IAgropecuaryFields) => {
  const {control, errors} = props;
  return (
    <>
      <Input
        control={control}
        name="sunagroCode"
        label="salesman-add-client-sunagro"
        error={errors?.sunagroCode as FieldError}
        rules={{
          required: 'form-is-required',
        }}
      />
      <Input
        control={control}
        name="insaiCode"
        label="salesman-add-client-insai"
        error={errors?.insaiCode as FieldError}
        rules={{
          required: 'form-is-required',
        }}
      />
    </>
  );
};
